import { SAuthentication } from "../types";
import {
  LOGIN_NO_COOKIE_SET,
  ISADMIN_SUCCESS,
  GOOGLELOGOUT_SUCCESS,
  GOOGLELOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  GOOGLELOGIN_ERROR,
  LOGIN_ACTIVE_DIRECTORY_ERROR,
  LOGIN_ACTIVE_DIRECTORY_SUCCESS,
  LOGIN_ERASE_ERROR,
  LOGIN_MICROSOFT_SUCCESS,
  LOGIN_MICROSOFT_ERROR,
} from "../actions";
import { AuthenticationActions } from "../actionCreators/authentication";

const initialState: SAuthentication = {
  user: undefined,
  googleLoggedIn: false,
  isUserAdmin: null,
  cookieChecked: false,
  noCookie: false,
  logout: false,
  microsoftLoggedIn: false,
};

const authenticationReducer = (
  state: SAuthentication = initialState,
  action: AuthenticationActions
): SAuthentication => {
  switch (action.type) {
    case LOGIN_ACTIVE_DIRECTORY_SUCCESS:
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        isUserAdmin: action.payload.isUserAdmin,
        cookieChecked: true,
        logout: false,
      };
    case LOGOUT_SUCCESS:
      return {
        user: undefined,
        googleLoggedIn: false,
        isUserAdmin: null,
        cookieChecked: false,
        noCookie: false,
        logout: false,
        microsoftLoggedIn: false,
      };
    case GOOGLELOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        googleLoggedIn: true,
        // gmail: action.gmail, TODO
        // gname: action.gname,
        // gimg: action.gimg,
        isUserAdmin: action.payload.isUserAdmin,
      };
    case GOOGLELOGOUT_SUCCESS:
      return {
        ...state,
        // gmail: null,
        // gname: null,
        // gimg: null,
        // googleLoggedIn: false,
        isUserAdmin: null,
      };
    case ISADMIN_SUCCESS:
      return {
        ...state,
        isUserAdmin: action.payload.data,
      };
    case LOGIN_NO_COOKIE_SET:
      return {
        ...state,
        cookieChecked: true,
        noCookie: true,
      };
    case LOGIN_ACTIVE_DIRECTORY_ERROR:
    case GOOGLELOGIN_ERROR:
    case LOGIN_ERROR:
      return {
        ...state,
        errors: action.errors,
      };
    case LOGIN_ERASE_ERROR: {
      const stateCpy = { ...state };
      delete stateCpy.errors;

      return stateCpy;
    }
    case LOGIN_MICROSOFT_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        cookieChecked: true,
        logout: false,
        isUserAdmin: action.payload.isUserAdmin,
        microsoftLoggedIn: true,
      };
    case LOGIN_MICROSOFT_ERROR:
      return {
        ...state,
        errors: action.errors,
      };
    default:
      return state;
  }
};

export default authenticationReducer;
